import React from "react";

const LargeHeader = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => (
  <div
    className={`${className} text-4xl sm:text-5xl text-secondary`}
    {...rest}
  />
);

export default LargeHeader;
